<script>
import ButtonComponent from '@/components/base-components/buttons/ButtonComponent.vue';
import XMarkIcon from '@/assets/img/XMarkIcon.vue';
import AppLink from '@/components/base-components/AppLink.vue';
import BaseInput from '@/components/base-components/BaseInput.vue';
import VisaicV3Analytics from '@/components/base-components/Analytics/VisaicV3Analytics';

export default {
  name: 'ShareClipPopup',
  components: {
    BaseInput,
    AppLink,
    XMarkIcon,
    ButtonComponent,
  },
  props: {
    clip: {
      type: Object,
      required: true,
    },
    eventId: {
      type: [String, Number],
      required: true,
    },
    ok: {
      type: Function,
      required: true,
    },
  },
  computed: {
    url() {
      return `${window.location.origin}/share/${this.eventId}/${this.clip.uuid}`;
    },
    shareEmail() {
      return `mailto:?subject=Check%20this%20out!&body=${encodeURIComponent(
          this.url,
      )}`;
    },
    shareFacebook() {
      return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
          this.url,
      )}`;
    },
    shareTwitter() {
      return `https://twitter.com/intent/tweet?url=${encodeURIComponent(this.url)}`;
    },
    shareWhatsApp() {
      return `https://api.whatsapp.com/send?text=${encodeURIComponent(this.url)}`;
    },
  },
  methods: {
    copyUrl() {
      const urlInput = this.$refs.urlInput?.$refs?.input;
      urlInput.select();
      document.execCommand('copy');
      this.onInputSelect();
    },
    onLinkClick(e) {
      e?.preventDefault();
      const link = e.target.closest('a');
      const href = link?.href;
      const sharedMethod = e.target.getAttribute('alt');
      this.triggerEvent({
        method: sharedMethod,
        href,
      });
    },
    onInputSelect() {
      this.triggerEvent({
        method: 'copy',
        href: this.url,
      });
    },
    triggerEvent({method, href}) {
      VisaicV3Analytics.event({
        event: 'share_clip',
        share_method: method,
        share_link: href,
        clip_uuid: this.clip.uuid,
        clip_id: this.clip.id,
        event_id: this.clip.event_id,
        is_owner: this.clip.is_owner,
        timestamp: Math.floor(Date.now() / 1000),
      });
    },
  },
  mounted() {
    this.$refs.urlInput?.$refs?.input.addEventListener('copy', this.onInputSelect);
  },
  beforeDestroy() {
    this.$refs.urlInput?.$refs?.input.removeEventListener('copy', this.onInputSelect);
  },
};
</script>

<template>
  <div
    class="popup-element"
    @click.stop
    v-click-outside="ok"
  >
    <h2 class="mb-3">{{ $t('CLIP.ShareClip') }}</h2>
    <button-component
      variant="icon"
      @btn-click="ok"
      class="popup-element__close"
      title="Close"
    >
      <x-mark-icon/>
    </button-component>
    <div class="d-flex gap-1 flex-wrap share-buttons" @click="onLinkClick">
        <app-link :to="shareEmail">
          <img src="/image/share/icon_email.png" alt="Email"/>
        </app-link>
        <app-link :to="shareFacebook">
          <img src="/image/share/icon_facebook.png" alt="Facebook"/>
        </app-link>
        <app-link :to="shareTwitter">
          <img src="/image/share/icon_x.png" alt="X"/>
        </app-link>
        <app-link :to="shareWhatsApp">
          <img src="/image/share/icon_WhatsApp.png" alt="WhatsApp"/>
        </app-link>
      </div>
      <div class="d-flex flex-column gap-1 mt-5 w-100">
        <base-input
            class="input-style"
            type="text"
            :value="url"
            ref="urlInput"
            readonly
        />
        <button-component
            class="align-self-end"
            @btn-click="copyUrl"
            title="Copy Link"
        >
          {{ $t('Copy Link') }}
        </button-component>
    </div>
  </div>
</template>
